import { IRoute } from 'types/index'

type TFunctionGuard = (route: IRoute) => boolean

const guard: TFunctionGuard = (route: IRoute): boolean => !route.secure;

export default guard